module.exports = function () {

  const d = new Date()

  // convert to msec since Jan 1 1970
  const localTime = d.getTime()

  // obtain local UTC offset and convert to msec
  const localOffset = d.getTimezoneOffset() * 60 * 1000

  // obtain UTC time in msec
  const utcTime = localTime + localOffset

  // obtain and add destination's UTC time offset
  const estOffset = getEstOffset()
  const usa = utcTime + (60 * 60 * 1000 * estOffset)

  // Get time zone offset for Los Angeles, USA (America/Los_Angeles)
  function getEstOffset () {
    const stdTimezoneOffset = () => {
      var jan = new Date(0, 1)
      var jul = new Date(6, 1)
      return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset())
    }

    var today = new Date()
    
    const isDstObserved = (today) => {
      return today.getTimezoneOffset() < stdTimezoneOffset()
    }

    if (isDstObserved(today)) {
      return -7
    } else {
      return -8
    }
  }

  // convert msec value to date string
  return new Date(usa)

}